import { render } from "./UpdateTemplate.vue?vue&type=template&id=c8650402"
import script from "./UpdateTemplate.vue?vue&type=script&lang=js"
export * from "./UpdateTemplate.vue?vue&type=script&lang=js"

import "./UpdateTemplate.vue?vue&type=style&index=0&id=c8650402&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__